import { reducer } from "ts-action";
import { withLoadingReducer } from "../../../Components/Pickup/redux-store/reducers/withLoadingState";
import { editMultiPosGiftListAction } from "../../../constants";

export default withLoadingReducer(reducer([], {}), editMultiPosGiftListAction);
